import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconInstagram: React.FC<IconProps> = ({ width = 21, height = 21, color = 'white' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 21 21"
            fill="none"
        >
            <g clip-path="url(#clip0_10468_176)">
                <path
                    d="M10.6599 19.492C10.366 19.492 10.0827 19.3855 9.86196 19.1921C9.02815 18.463 8.22426 17.7779 7.51501 17.1735L7.51139 17.1704C5.43198 15.3983 3.63634 13.868 2.38697 12.3606C0.990357 10.6753 0.339844 9.07743 0.339844 7.33186C0.339844 5.63589 0.921384 4.07126 1.97723 2.92597C3.04567 1.76714 4.51172 1.12891 6.1058 1.12891C7.29723 1.12891 8.38835 1.50558 9.34876 2.24837C9.83346 2.62331 10.2728 3.08218 10.6599 3.61743C11.0471 3.08218 11.4863 2.62331 11.9711 2.24837C12.9315 1.50558 14.0227 1.12891 15.2141 1.12891C16.808 1.12891 18.2742 1.76714 19.3427 2.92597C20.3985 4.07126 20.9799 5.63589 20.9799 7.33186C20.9799 9.07743 20.3295 10.6753 18.9329 12.3604C17.6835 13.868 15.8881 15.3982 13.809 17.17C13.0985 17.7754 12.2933 18.4616 11.4576 19.1924C11.237 19.3855 10.9535 19.492 10.6599 19.492ZM6.1058 2.33797C4.85344 2.33797 3.70295 2.83779 2.86599 3.74545C2.0166 4.66682 1.54875 5.94044 1.54875 7.33186C1.54875 8.79997 2.09439 10.113 3.31778 11.5891C4.50023 13.0159 6.25902 14.5148 8.29544 16.2503L8.29922 16.2534C9.01114 16.8601 9.81818 17.548 10.6581 18.2824C11.5031 17.5466 12.3114 16.8576 13.0248 16.2499C15.061 14.5144 16.8197 13.0159 18.0021 11.5891C19.2253 10.113 19.771 8.79997 19.771 7.33186C19.771 5.94044 19.3031 4.66682 18.4537 3.74545C17.6169 2.83779 16.4663 2.33797 15.2141 2.33797C14.2967 2.33797 13.4543 2.62961 12.7106 3.20469C12.0478 3.71742 11.5861 4.36557 11.3154 4.81909C11.1762 5.05231 10.9312 5.19151 10.6599 5.19151C10.3885 5.19151 10.1435 5.05231 10.0043 4.81909C9.73378 4.36557 9.27207 3.71742 8.60912 3.20469C7.86539 2.62961 7.02307 2.33797 6.1058 2.33797Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10468_176">
                    <rect
                        width="20.6401"
                        height="20.6401"
                        fill={color}
                        transform="translate(0.339844)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconInstagram;
